module.exports = __webpack_public_path__ + "static/media/account.c2165a8c.svg";